import React from "react";
import { Container } from "react-bootstrap";

interface BannerProps {
    backgroundImage: string;
    title: string;
    subtitle: string;
}

const Banner: React.FC<BannerProps> = ({ backgroundImage, title, subtitle }) => {
    return (
        <div
            className="d-flex align-items-center sans-serif text-white text-shadow"
            style={{ background: `url(${backgroundImage})`, backgroundPosition: "top left", backgroundRepeat: "no-repeat", backgroundSize: "cover", height: "300px" }}
        >
            <Container>
                <h1 className="display-5 lh-1 sans-serif fw-bold m-0">{title}</h1>
                <p className="fs-2 fw-bold text-uppercase my-2">{subtitle}</p>
            </Container>
        </div>
    );
};

export default Banner;
